var isArrayLikeObject = {};
export {
  isArrayLikeObject as __exports
};
//# sourceMappingURL=isArrayLikeObject.js.map
